<div class="register-form relative-left full-width">
  <!-- register form -->
  <form [formGroup]="registerForm" class="relative-left full-width">
    <div class="head-form relative txt-center light-2">
      <h3>
        {{'formTitle.a' | translate}}
        <strong class="block"> {{'formTitle.b' | translate}} </strong>
      </h3>
    </div>

    <div class="relative-left padding-left-right-20">
      <div class="relative-left full-width margin-top-bottom-10 two-boxes">
        <mat-form-field class="box">
          <mat-label>{{'form.fname' | translate}}</mat-label>
          <input formControlName="name" type="text" matInput placeholder="{{'form.fnameExample' | translate }}" />
          <mat-icon matPrefix>account_circle</mat-icon>
          <mat-error *ngIf="registerForm.get('name').hasError('required')"> {{'LOGIN.VALIDATE.NAME.REQUIRED' | translate}} </mat-error>
          <mat-error *ngIf="registerForm.get('name').hasError('minlength') || registerForm.get('name').errors?.pattern">
            {{'LOGIN.VALIDATE.NAME.ENTER' | translate}}
          </mat-error>
          <mat-error *ngIf="registerForm.get('name').errors?.maxlength"> {{'LOGIN.VALIDATE.NAME.MAXIMUN' | translate}} </mat-error>
        </mat-form-field>
        <mat-form-field class="box">
          <mat-label>{{'form.lname' | translate}}</mat-label>
          <input formControlName="last_name" type="text" matInput placeholder="{{'form.lnameExample' | translate }}" />
          <mat-icon matPrefix>account_circle</mat-icon>
          <mat-error *ngIf="registerForm.get('last_name').errors?.required"> {{'LOGIN.VALIDATE.NAME.REQUIRED' | translate}} </mat-error>
          <mat-error *ngIf="registerForm.get('last_name').errors?.minlength || registerForm.get('last_name').errors?.pattern">
            {{'LOGIN.VALIDATE.NAME.ENTER' | translate}}
          </mat-error>
          <mat-error *ngIf="registerForm.get('last_name').errors?.maxlength"> {{'LOGIN.VALIDATE.NAME.MAXIMUN' | translate}} </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="relative-left full-width two-boxes padding-left-right-20">
      <mat-form-field class="box">
        <mat-label>{{'form.pass' | translate}}</mat-label>
        <input formControlName="password" matInput placeholder="{{'form.passExample' | translate }}" [type]="isHide ? 'password' : 'text'" />
        <mat-icon matPrefix>lock</mat-icon>
        <mat-icon class="pointer" matSuffix (click)="showPassword()"> {{isHide ? 'visibility_off' : 'visibility'}}</mat-icon>
        <mat-error *ngIf="registerForm.get('password').errors?.required"> {{'LOGIN.VALIDATE.PASSWORD.ENTER' | translate}} </mat-error>
        <mat-error *ngIf="registerForm.get('password').errors?.minlength"> {{'LOGIN.VALIDATE.PASSWORD.MINIMUN' | translate}} </mat-error>
        <mat-error *ngIf="registerForm.get('password').errors?.pattern"> {{'LOGIN.VALIDATE.PASSWORD.SPECIALCHAR' | translate}} </mat-error>
        <mat-error *ngIf="registerForm.get('password').errors?.maxlength"> {{'LOGIN.VALIDATE.PASSWORD.MAXIMUN' | translate}} </mat-error>
      </mat-form-field>
      <mat-form-field class="box">
        <mat-label>{{'form.email' | translate}}</mat-label>
        <input
          oninput="this.value = this.value.toLowerCase()"
          formControlName="email"
          type="email"
          matInput
          placeholder="{{'form.emailExample' | translate }}"
          (ngModelChange)="errorMailExist = false"
        />
        <mat-icon matPrefix>email</mat-icon>
        <mat-error *ngIf="registerForm.get('email').errors?.pattern || registerForm.get('email').errors?.email">
          {{'LOGIN.VALIDATE.MAIL.ENTER' | translate}}
        </mat-error>
        <mat-error *ngIf="registerForm.get('email').errors?.required"> {{'LOGIN.VALIDATE.MAIL.REQUIRED' | translate}} </mat-error>
        <mat-error *ngIf="errorMailExist"> <span (click)="changeState($event)">{{'LOGIN.VALIDATE.MAIL.EXISTS' | translate}}</span></mat-error>
      </mat-form-field>
    </div>

    <!-- Begin Country -->
    <mat-form-field class="full-width margin-top-bottom-10 padding-left-right-20">
      <mat-label>{{'LOGIN.PLACEHOLDER.COUNTRY' | translate}}</mat-label>
      <input
        type="text"
        placeholder="Ex. Canadá"
        aria-label="Your Country"
        matInput
        formControlName="country"
        [matAutocomplete]="auto"
        placeholder="{{'form.countryExample' | translate }}"
        (ngModelChange)="setDialCode();countryControls();getCountry()"
      />
      <mat-icon matPrefix>landscape</mat-icon>
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let option of filteredCountries | async" [value]="option.name"> {{option.name}} </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="registerForm.get('country').hasError"> {{'LOGIN.VALIDATE.COUNTRY.ENTER' | translate}} </mat-error>
    </mat-form-field>
    <!-- End Country -->

    <!-- Begin State -->
    <mat-form-field *ngIf="showState" class="full-width margin-top-bottom-10 padding-left-right-20">
      <mat-label>{{'LOGIN.PLACEHOLDER.STATE' | translate}}</mat-label>
      <input
        type="text"
        aria-label="Your State"
        matInput
        formControlName="state"
        [matAutocomplete]="auto"
        placeholder="{{'form.stateExample' | translate }}"
      />
      <mat-icon matPrefix>landscape</mat-icon>
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let states of filteredStates | async" [value]="states.name"> {{states.name}} </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="registerForm.get('state').hasError"> {{'LOGIN.VALIDATE.STATE.ENTER' | translate}} </mat-error>
    </mat-form-field>
    <!-- End State -->
    <!-- Begin CPF -->
    <mat-form-field class="full-width margin-top-bottom-10 padding-left-right-20" *ngIf="country?.iso ==='CO' || country?.iso ==='BR'">
      <mat-label>{{'CPF.TITLE' | translate}}</mat-label>
      <input oninput="this.value = this.value.toLowerCase()" formControlName="ssn" type="text" matInput placeholder="" />
      <mat-icon matPrefix>person_pin</mat-icon>
      <mat-error *ngIf="errorCpfInvalid" style="float: right; text-align: left; font-size: 12px"> {{'CPF.CONTENT' | translate}} </mat-error>
    </mat-form-field>
    <!-- End CPF -->
    <!-- Begin Birthday -->
    <mat-form-field class="full-width margin-top-bottom-10 padding-left-right-20">
      <mat-label>{{'form.birthday' | translate}}</mat-label>
      <input type="date" placeholder="" aria-label="Your Birthday" matInput formControlName="birthdate" />
      <!-- <mat-icon matPrefix>calendar_today</mat-icon> -->
      <mat-error *ngIf="onValidator('birthdate', 'required')"> {{'LOGIN.VALIDATE.AGE.ENTER' | translate}} </mat-error>
      <mat-error *ngIf="onValidator('birthdate', 'NotAdult')"> {{'LOGIN.VALIDATE.AGE.MINIMUN' | translate}} </mat-error>
      <mat-error *ngIf="onValidator('birthdate', 'TooOld')"> {{'LOGIN.VALIDATE.AGE.MAXIMUN' | translate}} </mat-error>
    </mat-form-field>
    <!-- End Birthday -->
    <!-- Begin Phone -->
    <mat-form-field class="full-width margin-top-bottom-10 padding-left-right-20">
      <mat-label>{{'form.phone' | translate}}</mat-label>
      <span matPrefix *ngIf="!dialcode.isValid"> +&nbsp; </span>
      <span matPrefix *ngIf="dialcode.isValid">
        <img class="inline-block margin-right-5" [attr.src]="'https://flagcdn.com/'+ dialcode.alpha2Code.toLowerCase() + '.svg'" width="20" />
        <small class="relative normal-10 dialcode-print-number inline-block"> +{{dialcode.callingCodes[0]}}&nbsp; </small>
      </span>
      <input
        formControlName="phone"
        type="text"
        matInput
        placeholder="{{'form.phoneExample' | translate}}"
        (ngModelChange)="this.errorNumberPhone = false"
      />
      <mat-icon matPrefix>smartphone</mat-icon>
      <mat-error *ngIf="registerForm.get('phone').hasError('pattern')"> {{'LOGIN.VALIDATE.PHONE.ONLY' | translate}} </mat-error>
    </mat-form-field>
    <div class="full-width two-boxes margin-bottom-10 relative bottom-15">
      <p *ngIf="onValidator('phone', 'maxlength') || errorNumberPhone" class="form-note relative-left box">
        <small>
          <span class="login-error-msg"> {{'LOGIN.VALIDATE.PHONE.ENTER' | translate}} </span>
        </small>
      </p>
    </div>
    <!-- End Phone -->
    <!-- Begin Direction -->
    <mat-form-field class="full-width margin-top-bottom-10 padding-left-right-20">
      <mat-label>{{'form.direccion' | translate}}</mat-label>
      <input
        type="text"
        placeholder="Ex. Canadá"
        aria-label="Your Country"
        matInput
        formControlName="address1"
        placeholder="{{'form.countryExample' | translate }}"
        (ngModelChange)="setDialCode();countryControls();getCountry()"
      />
      <mat-icon matPrefix>domain</mat-icon>
      <mat-error *ngIf="registerForm.get('address1').hasError"> {{'form.error' | translate}} </mat-error>
    </mat-form-field>
    <!-- End Direction -->

    <div *ngIf="isStep"><!-- Not used--></div>
    <div class="relative-left full-width txt-center padding-left-right-20">
      <button mat-button class="play-now button md full-width" (click)="changeStep($event)">
        {{'PlayNow' | translate}}
      </button>

      <div class="terms-container full-width">
        <mat-checkbox [checked]="acceptTerms ? true : false" (change)="onCheckboxChange($event)" class="terms" style="margin-left: 20px">
        </mat-checkbox>
        <p style="font-size: 12px !important; line-height: 35px; margin-left: 5px; color: #222" *ngIf="('lang' | translate) === 'es'">
          <span style="text-transform: Capitalize; line-height: 35px">Confirmo </span>que acepto los
          <span class="link" (click)="redirecToTerms()">términos y condiciones</span>
        </p>
        <p style="font-size: 12px !important; line-height: 35px; margin-left: 5px; color: #222" *ngIf="('lang' | translate) === 'en'">
          <span style="text-transform: Capitalize; line-height: 35px">I confirm </span>I accept them
          <span class="link" (click)="redirecToTerms()">terms and Conditions</span>
        </p>
        <p style="font-size: 12px !important; line-height: 35px; margin-left: 5px; color: #222" *ngIf="('lang' | translate) === 'pt'">
          <span style="text-transform: Capitalize; line-height: 35px">Confirmar </span>que aceito los
          <span class="link" (click)="redirecToTerms()">términos y condiciones</span>
        </p>
      </div>
      <h4 *ngIf="error && !loading" class="login-error-msg full-width txt-center padding-5">{{'ERROR.GENERIC' | translate}}</h4>
      <h4 *ngIf="errorFormInvalid" class="login-error-msg full-width txt-center padding-5">{{'ERROR.GENERIC' | translate}}</h4>
      <h4 *ngIf="errorMailExist" class="login-error-msg full-width txt-center padding-5">{{'LOGIN.VALIDATE.MAIL.EXISTS' | translate}}</h4>
      <h4 *ngIf="errorCpfInvalid" class="login-error-msg full-width txt-center padding-5">{{'CPF.CONTENT' | translate}}</h4>
      <h4 *ngIf="errorNumberPhone" class="login-error-msg full-width txt-center padding-5">{{'LOGIN.VALIDATE.PHONE.ENTER' | translate}}</h4>
      <h4 *ngIf="errorInvalidState" class="login-error-msg full-width txt-center padding-5">{{'LOGIN.VALIDATE.STATE.ENTER' | translate}}</h4>
      <div *ngIf="loading">
        <app-spinner></app-spinner>
      </div>
    </div>
  </form>

  <ng-container *ngIf="!forgotPass"> <!-- Not used--> </ng-container>
  <!-- Not used-->

  <div class="relative-left full-width margin-bottom-10 padding-20 padding-left-right-20">
    <ng-container *ngIf="sys === 'wt'">
      <ng-container *ngIf="('lang' | translate) === 'en'">
        <img src="https://d3tmfelegj51yl.cloudfront.net/global-json/secure-payment/wt/en/secure-payment.png" alt="" />
      </ng-container>
      <ng-container *ngIf="('lang' | translate) === 'es' || ('lang' | translate) === 'pt'">
        <img src="https://d3tmfelegj51yl.cloudfront.net/global-json/secure-payment/wt/es/secure-payment.png" alt="" />
      </ng-container>
    </ng-container>
    <ng-container *ngIf="sys === 'ltk'">
      <ng-container *ngIf="('lang' | translate) === 'en'">
        <img src="https://d3tmfelegj51yl.cloudfront.net/global-json/secure-payment/ltk/en/secure-payment.png" alt="" />
      </ng-container>
      <ng-container *ngIf="('lang' | translate) === 'es' || ('lang' | translate) === 'pt'">
        <img src="https://d3tmfelegj51yl.cloudfront.net/global-json/secure-payment/ltk/en/secure-payment.png" alt="" />
      </ng-container>
    </ng-container>
  </div>
</div>
